import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './styles/global.css';

import useReveal from './hooks/useReveal';

import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Ticker from './components/Ticker/Ticker';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Services from './components/Services/Services';
import Creators from './components/Creators/Creators';
import Business from './components/Business/Business';
import Testimonials from './components/Testimonials/Testimonials';
import Pricing from './components/Pricing/Pricing';
import ForCreators from './components/ForCreators/ForCreators';
import AppSection from './components/AppSection/AppSection';
import FAQ from './components/FAQ/FAQ';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import WeddingPackages from './components/Wedding/WeddingPackages';
import InstagramSection from './components/InstagramSection/InstagramSection';

import ReactGA from './analytics';

// ── Admin lazy load ─────────────────────────
const AdminApp = React.lazy(() => import('./admin/AdminApp'));
// Client page is lightweight but still lazy — not in main bundle

const EventClientPage = React.lazy(() => import('./admin/pages/Eventclientpage'));


// ── Public Site ─────────────────────────────
function PublicSite() {
  useReveal();

  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
  });

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Ticker />
      <InstagramSection />
      <HowItWorks />
      <Services />
      <Pricing />
      <WeddingPackages />

      {/* Optional */}
      {/* <Creators /> */}
      {/* <Business /> */}
      {/* <Testimonials /> */}

      <ForCreators />
      <AppSection />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

// ── Root App ────────────────────────────────
function App() {
  return (
    <BrowserRouter>
      <Routes>
          {/* ── Public client event page ─────────────────────────────
            URL: /event/<eventId>
            e.g. https://gosnap.in/event/abc123xyz
            No login required. Real-time Firestore.            */}
        <Route
          path="/event/:eventId"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <EventClientPage />
            </React.Suspense>
          }
        />

        {/* Admin Panel */}
        <Route
          path="/gs-admin/*"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <AdminApp />
            </React.Suspense>
          }
        />

        {/* Public Website */}
        <Route path="*" element={<PublicSite />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;